var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { StorageService } from '../storage.service';
import { HttpService } from '../common/http.service';
import { AppConstant } from '../app.constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
var SettingsService = /** @class */ (function () {
    function SettingsService(httpService, storage, _http) {
        this.httpService = httpService;
        this.storage = storage;
        this._http = _http;
        this.header = new HttpHeaders();
        this.header = this.header.append('Content-Type', 'application/json');
        // console.log(' this is get category');
        //  this.getCategory()
        //    .subscribe((res) => {
        //      console.log(res);
        //      this.cacheCategory(res.businessType);
        //    });
    }
    SettingsService.prototype.cacheCategory = function (catId) {
        if (catId) {
            this.storage.setCategory(catId);
            this.categoryName = this.getCategoriesName(catId);
        }
        else {
            // console.log('category not found');
        }
    };
    SettingsService.prototype.getProfile = function () {
        return this.httpService.get('/settings/profile', null);
    };
    SettingsService.prototype.updateProfile = function (data) {
        return this.httpService.put('/settings/profile', data);
    };
    SettingsService.prototype.changePassword = function (data) {
        //  return this.httpService.put('/settings/change-password', data);
        var options = { headers: this.header };
        return this._http.put(AppConstant.AWS_API_ENDPOINT + '/settings/change_password', data, options);
    };
    SettingsService.prototype.getCategory = function () {
        return this.httpService.get('/settings/category', null);
    };
    SettingsService.prototype.changeCategory = function (category) {
        var _this = this;
        return new Observable(function (observer) {
            _this.setCategory(category)
                .subscribe(function () {
                _this.cacheCategory(category.businessType);
                observer.next(_this.getCategoriesName(category.businessType));
            });
        });
    };
    SettingsService.prototype.getCategoryName = function (catId) {
        this.categoryName = AppConstant.BUSINESS_NAMES[catId];
        return this.categoryName;
    };
    SettingsService.prototype.getCategoriesName = function (catId) {
        if (catId === 1) {
            this.pickup = localStorage.getItem('appPickupText');
            this.delivery = localStorage.getItem('appDeliveryText');
            this.pickupDelivery1 = this.pickup + ' ' + '&' + ' ' + this.delivery;
            AppConstant.BUSINESS_NAMES[0] = this.pickupDelivery1;
            this.categoryName = AppConstant.BUSINESS_NAMES[0];
            return this.categoryName;
        }
        else if (catId === 2) {
            this.appointment1 = localStorage.getItem('appAppointmentText');
            AppConstant.BUSINESS_NAMES[0] = this.appointment1;
            this.categoryName = AppConstant.BUSINESS_NAMES[0];
            return this.categoryName;
        }
        else if (catId === 3) {
            this.fieldWorkForce1 = localStorage.getItem('appFieldWorkForceText');
            AppConstant.BUSINESS_NAMES[0] = this.fieldWorkForce1;
            this.categoryName = AppConstant.BUSINESS_NAMES[0];
            return this.categoryName;
        }
    };
    SettingsService.prototype.setCategory = function (data) {
        return this.httpService.put('/settings/category', data);
    };
    SettingsService.prototype.setNotification = function (data) {
        // console.log(JSON.stringify(data));
        return this.httpService.put('/settings/notification', data);
    };
    SettingsService.prototype.getNotification = function () {
        // console.log('hello');
        return this.httpService.get('/settings/notification', null);
    };
    SettingsService.prototype.setPreference = function (info) {
        // console.log(JSON.stringify('settings update', info));
        return this.httpService.put('/settings/preference', info);
    };
    SettingsService.prototype.getPreference = function () {
        return this.httpService.get('/settings/preference', null);
    };
    SettingsService.prototype.GetApiKey = function () {
        return this.httpService.get('/settings/developer', null);
    };
    SettingsService.prototype.setApiKey = function (data) {
        return this.httpService.post('/settings/developer', data);
    };
    SettingsService.prototype.deleteApiKey = function (data) {
        return this.httpService.delete('/settings/developer', data);
    };
    SettingsService.prototype.setAccountSettings = function (data) {
        // console.log(JSON.stringify(data));
        return this.httpService.put('/settings/application-setup', data);
    };
    SettingsService.prototype.getAccountSettings = function () {
        return this.httpService.get('/settings/application-setup', null);
    };
    SettingsService.prototype.setAutoAllocation = function (data) {
        return this.httpService.put('/settings/auto-allocation', data);
    };
    SettingsService.prototype.getAutoAllocation = function () {
        return this.httpService.get('/settings/auto-allocation', null);
    };
    // postSms(data) {
    //   return this.httpService.post('/settings/sms', data);
    // }
    SettingsService.prototype.getSms = function () {
        return this.httpService.get('/settings/sms', null);
    };
    SettingsService.prototype.updateSms = function (data) {
        return this.httpService.put('/settings/sms', data);
    };
    SettingsService.prototype.updateWhatsapp = function (data) {
        return this.httpService.put('/settings/whatsapp', data);
    };
    SettingsService.prototype.getWhatsapp = function () {
        return this.httpService.get('/settings/whatsapp', null);
    };
    SettingsService.prototype.getCrm = function () {
        return this.httpService.get('/settings/crm', null);
    };
    SettingsService.prototype.postCrm = function (data) {
        return this.httpService.post('/crmconnector', data);
    };
    SettingsService.prototype.updateCrm = function (data) {
        return this.httpService.post('/crmconnector', data);
    };
    SettingsService.prototype.getStaticData = function (data) {
        // console.log(data);
        return this.httpService.get('/terms_and_policy', null);
    };
    SettingsService.prototype.taskStatusUpdate = function (data) {
        // console.log(data);
        return this.httpService.put('/settings/taskstatus', data);
    };
    SettingsService.prototype.handleError = function (error) {
        return Observable.throw(error);
    };
    SettingsService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpService, StorageService, HttpClient])
    ], SettingsService);
    return SettingsService;
}());
export { SettingsService };



//////////////////
// WEBPACK FOOTER
// ./src/app/settings/settings.service.ts
// module id = ./src/app/settings/settings.service.ts
// module chunks = main